import { useEffect, useState } from "react";
import { Map, useMap } from "@vis.gl/react-google-maps";
import SearchInput from "../components/SearchInput";
import ImageSearchReassu from "../img/search_reassu.png";

const UpdatableMap = ({ placeSelected }) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !placeSelected) return;
    if (placeSelected.location)
    {
      map.setCenter(placeSelected.location);
      map.setZoom(20);
    }
  }, [map, placeSelected]);

  return (
    placeSelected && 
    <Map
      zoom={20}
      tilt={45}
      mapTypeId={'satellite'}
      defaultCenter={placeSelected.location}
      gestureHandling={'none'}
      disableDefaultUI={true}>
    </Map>
  )
}

const BeginStep = ({ initialProps }) => {
  const [placeSelected, setPlaceSelected] = useState(null);

  return (
    <>
      <div className="left">
        <UpdatableMap placeSelected={placeSelected}/>
      </div>
      <div className="right">
        <h2>Votre simulation solaire en 5 mn !</h2>
        <div className="advantages">
          👉&nbsp;&nbsp;Gratuit et sans engagement<br/>
          😊&nbsp;&nbsp;Ludique et rapide<br/>
          ❤️&nbsp;&nbsp;<b>4,8/5 - Excellent</b>
        </div>
        <div className="search">
          <SearchInput onPlaceSelect={setPlaceSelected} initAddr={initialProps?.addr}/>
        </div>
        <img src={ImageSearchReassu} className="reassu" width={291} alt="Certifications"/>
      </div>
    </>
  )
}

export default BeginStep;